import { resource, resourceCollection, resourceGroup } from "assets/svg/purple";
import NuxLayout from "components/UI/molecules/NuxLayout";
import ManageWrapper from "components/UI/organisms/ManageWrapper";
import useFilters, { FILTER_TYPES } from "helpers/hooks/useFilters";
import useListingHeader from "helpers/hooks/useListingHeader";
import { COLORS, COMPONENT_TYPES } from "helpers/utils/constants";
import React, { useEffect, useState } from "react";
import useResources from "store/resources/service-hook";
import ResourceListing from "./ResourceListing";
import useBrowseOptions from "helpers/hooks/useBrowseOptions";
import useGO1 from "store/go1/service-hook";
import GO1ResourceBuilder from "../go1/ResourceBuilder";
import useRedirect from "helpers/hooks/useRedirect";
import { edit } from "assets/svg/white";
import { openai } from "assets/svg/green";
import { go1 } from "assets/svg";
// import { useSelector } from "react-redux";
// import { REDUCER_TYPES } from "store";
import EmptyText from "components/UI/atoms/EmptyText";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";

export const getResourceNUX = (onClick) => ({
  0: {
    title: "You have no Resources. Let’s create your first Resource!",
    nuxCardData: {
      title: "Create Your First Resource",
      icon: resource,
      bgColor: COLORS.DARK_RED,
      onClick,
    },
  },
  1: {
    title:
      "You have no Resource Collections. Lets create your first Resource Collection",
    nuxCardData: {
      title: "Create Your First Resource Collection",
      icon: resourceCollection,
      bgColor: COLORS.DARK_RED,
      onClick,
    },
  },
  2: {
    title: "You have no Resource groups. Lets create your first Resource group",
    nuxCardData: {
      title: "Create Your First Resource group",
      icon: resourceGroup,
      bgColor: COLORS.DARK_BLUE,
      onClick,
    },
  },
});

export const useResourceCreateOptions = (setModal) => {
  const { navigateCreateResource, navigateCreateResourceModuleAI } =
    useRedirect();
  // const { user } = useSelector((state) => state[REDUCER_TYPES.AUTH]);
  return [
    {
      id: "go1",
      icon: go1,
      title: "From Go1 Platform",
      tooltip: "Please purchase the Go1 Add On to unlock this feature",
      // tooltip:
      //   !user?.go1?.can_create_resource &&
      //   "This feature needs to be activated by your Organization admin.",
      description:
        "Select a Course from Go1 repository to quickly get started.",
      color: "#D3FF00",
      onClick: () => setModal("go1"),
      // disabled: !user?.go1?.can_create_resource,
      disabled: true,
    },
    {
      id: "ai",
      icon: openai,
      title: "From Resource Module Builder AI",
      description:
        "Start your Resource Module creation journey in only a few steps with the help of AI.",
      color: COLORS.GREEN,
      onClick: () => navigateCreateResourceModuleAI(),
    },
    {
      id: "scratch",
      icon: edit,
      title: "From Scratch",
      description: "Want to create a Resource Module manually?",
      color: COLORS.YELLOW,
      closeOnClick: true,
      onClick: () => navigateCreateResource(),
    },
  ];
};

const ManageResources = () => {
  const state = useListingHeader();
  const [resources, setResources] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const { fetchMyResources, deleteResource } = useResources();
  const { selected, clearAll } = useFilters();
  const browseOptions = useBrowseOptions(COMPONENT_TYPES.RESOURCE);
  const [modal, setModal] = useState(null);
  const { topics, providers } = useGO1();
  const { t } = useLocalizedTranslation();
  const { navigateCreateResource } = useRedirect();

  const resourceCreateOptions = useResourceCreateOptions(setModal);

  useEffect(() => {
    topics();
    providers();
  }, []);

  useEffect(() => {
    if (modal === "go1") return;
    handleFetchResources();
  }, [page, selected, state.sort, state.search]);

  const handleFetchResources = async () => {
    setLoading(true);
    const filters = {
      ...selected,
      page,
      sort_by: state.sort,
    };
    if (state.search) {
      filters.search = state.search;
    }
    if (filters.resource_source) {
      filters.source = selected.resource_source;
      delete filters.resource_source;
    }
    if (selected?.multi_type) filters.type = selected.multi_type;
    delete filters.multi_type;

    const [list, count, totalCount] = await fetchMyResources({ ...filters });
    setResources(list || []);
    setPages(count || 0);
    setTotalCount(totalCount || 0);
    setLoading(false);
  };

  const handleDeleteResourceModule = async (slug) => {
    setLoading(true);
    await deleteResource(slug);
    setResources((val) => val.filter((d) => d.slug !== slug));
    setLoading(false);
  };

  const handleModalOpen = () => setModal("create");
  const handleModalClose = () => {
    if (modal === "go1") {
      clearAll();
    }
    setModal(null);
  };

  return (
    <>
      <ManageWrapper
        {...state}
        browseMode={0}
        setBrowseMode={(val) => {}}
        browseOptions={browseOptions}
        navigateCreate={handleModalOpen}
        component={COMPONENT_TYPES.RESOURCE}
        filters={[
          FILTER_TYPES.MULTI_TYPE,
          FILTER_TYPES.DURATION,
          FILTER_TYPES.LEVEL,
          FILTER_TYPES.SKILLS,
          FILTER_TYPES.PRIVACY,
          FILTER_TYPES.RESOURCE_SOURCE,
          FILTER_TYPES.RATING,
          FILTER_TYPES.PROGRESS,
        ]}
        createOptions={resourceCreateOptions}
      >
        {!resources?.length &&
        !loading &&
        !Object.values(selected).some((d) => d?.length) ? (
          !state.search ? (
            <NuxLayout
              browseMode={0}
              newUserData={getResourceNUX(navigateCreateResource)}
            />
          ) : (
            <EmptyText>{t("No results found for this search!")}</EmptyText>
          )
        ) : (
          <>
            {totalCount > 0 && (
              <h3 className="mt-3 ml-1">
                {totalCount ?? 0} {t("Results", "common")}
              </h3>
            )}
            <ResourceListing
              browseMode={0}
              gridType={state.gridType}
              resources={resources}
              setResources={setResources}
              loading={loading}
              page={page}
              pageCount={pages}
              setPage={setPage}
              handleDelete={handleDeleteResourceModule}
              manage
              emptyMessage={t("No result found")}
            />
          </>
        )}
      </ManageWrapper>
      {modal === "go1" ? (
        <GO1ResourceBuilder open={modal} onClose={handleModalClose} />
      ) : null}
    </>
  );
};

export default ManageResources;
